const loadItems = (button) => {
  // 1) Récupère les infos courantes
  const totalPages = parseInt($('[data-total-pages]').val(), 10);
  const $dataBlock  = $('.infinite-scroll__data');
  const nextUrl     = $dataBlock.find('[data-next-url]').val();
  const currentPage = parseInt($dataBlock.find('[data-current-page]').val(), 10);

  // 2) Si on est déjà à la dernière page ou que nextUrl est vide, on stoppe tout
  if (!nextUrl || currentPage >= totalPages) {
    button && button.remove();
    return;
  }

  // 3) Affiche le loader et désactive le bouton
  button.setAttribute('disabled', '');
  button.classList.add('loading');

  // 4) Requête AJAX
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html'
  })
  .done((html) => {
    const $resp = $(html);

    // 4a) Injecte les nouveaux produits
    $('.load-more-grid').append(
      $resp.find('.load-more-grid').html()
    );
    colorSwatches();

    // 4b) Met à jour intégralement le bloc hidden avec les inputs générés par Shopify
    const newDataHtml = $resp.find('.infinite-scroll__data').html();
    $dataBlock.html(newDataHtml);
  })
  .fail((xhr, status, err) => {
    console.error('Échec du chargement :', err);
    // Optionnel : afficher un message utilisateur ici
  })
  .always(() => {
    // 5) Relance l’observation si on n’est pas encore à la dernière page
    const updatedPage = parseInt($dataBlock.find('[data-current-page]').val(), 10);
    if (updatedPage < totalPages) {
      checkVisibility();
      button.removeAttribute('disabled');
      button.classList.remove('loading');
    } else {
      // Plus de pages : on supprime le loader/bouton
      button && button.remove();
    }
  });
};

//const loadItems = (button) => {
//  const totalPages = parseInt($('[data-total-pages]').val());
//  let currentPage = parseInt($('[data-current-page]').val());
//  let currentPageScroll = currentPage + 1;

//  currentPage = currentPage+1;
//  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
//  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
//  $('[data-current-page]').val(currentPage);

//  button.setAttribute("disabled", "");
//  button.classList.add('loading');

//  $.ajax({
//    url: nextUrl,
//    type: 'GET',
//    dataType: 'html',
//    success: function(responseHTML){
//      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
//      colorSwatches();
//    },
//    complete: function() {
//      if (currentPage <= totalPages) {
//        const scollData = document.querySelector('.infinite-scroll__data');
//        if (scollData && currentPage != totalPages) {
//          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
//          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
//          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
//          scollData.querySelector('input[data-current-page]').value =  currentPage;
//          checkVisibility();
//        }
//        button.removeAttribute("disabled");
//        button.classList.remove('loading');
//        if (currentPage == totalPages) {
//          button.remove();
//        }
//      } 
//    }
//  })
//}


const animateImages = () => {
	console.log("I was called to animate images");
	const sections = document.querySelectorAll(".section-main-blog");

	sections.forEach(item => {
		if (item.querySelectorAll(".observe-me").length > 0) {
			function createObserver() {
					function handleIntersect(entries, observer) {
							entries.forEach(entry => {
									if (entry.isIntersecting) {
											let css_classlist = entry.target.classList;
											css_classlist.add("is-inview");

											observer.unobserve(entry.target);

											setTimeout(() => {
													css_classlist.remove("is-inview");
													css_classlist.remove("observe-me");
											}, 1000); // Duration matches the animation duration in SCSS
									}
							});
					}

					let options = {
							root: null,
							rootMargin: "0px",
							threshold: 0.0
					};

					let observer = new IntersectionObserver(handleIntersect, options);
					let targets = item.querySelectorAll(".observe-me");
					targets.forEach((target, index) => {
							observer.observe(target);
					});
			}

			createObserver();
		} 
	})
}

//const checkVisibility = () => {
//  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
//  spinnerList.forEach(spinner => {
//    const sectionObserver = new IntersectionObserver(
//      (entries) => {
//        entries.forEach((entry) => {
//          if (entry.isIntersecting) {
//            loadItems(spinner);
//						observer.unobserve(entry.target);
//          }
//        })
//      }
//    );
//
//    sectionObserver.observe(spinner);
//  })
//}

const checkVisibility = () => {
  document.querySelectorAll('.js-infinite-scroll').forEach((spinner) => {
    const sectionObserver = new IntersectionObserver(
      // On déclare bien les deux params : entries **et** observer
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // on lance le chargement…
            loadItems(spinner);
            // …puis on arrête d’observer ce spinner
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px' } // optionnel : pré-charge avant d’être visible
    );

    sectionObserver.observe(spinner);
  });
};


function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();

